import { render } from "./UserRoleCard.vue?vue&type=template&id=1218dcd2&scoped=true"
import script from "./UserRoleCard.vue?vue&type=script&lang=js"
export * from "./UserRoleCard.vue?vue&type=script&lang=js"

import "./UserRoleCard.vue?vue&type=style&index=0&id=1218dcd2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1218dcd2"]])

export default __exports__